const ScenarioDescriptions = ({ scenarioText }) => {
  const scenarios = {
    heading: "Scenario Descriptions",
    content: scenarioText,
  };

  return (
    <div className="scenarios">
      <div className="scenarios__heading-wrapper">
        <h2 className="scenarios__heading">{scenarios.heading}</h2>
      </div>
      {scenarios.content?.map((scenario, index) => (
        <div key={index}>
          <div className="scenarios__name-wrapper">
            <h3 className="scenarios__name">{scenario.label}</h3>
          </div>
          <div className="scenarios__description">{scenario.description}</div>
        </div>
      ))}
    </div>
  );
};

export default ScenarioDescriptions;
